import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=48a9dc4c&scoped=true&"
import script from "./TextAreaInput.vue?vue&type=script&lang=js&"
export * from "./TextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&id=48a9dc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9dc4c",
  null
  
)

export default component.exports